<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    persistent
    :width="dialogWidth"
    v-bind="$attrs"
  >
    <v-card class="mx-auto" :max-width="dialogWidth">
      <v-card-text class="text-center">
        <br />
        <i :class="iconClass" :style="iconStyle"></i>
      </v-card-text>
      <v-card-title class="d-flex justify-content-center">
        <p
          class="text-center font-weight-bold display-2"
          style="word-break: normal;"
        >
          {{ alertTitle }}
        </p>
      </v-card-title>
      <v-card-text v-if="text" class="d-flex justify-content-center">
        <p
          class="text-center headline text--primary"
          style="word-break: normal;"
        >
          {{ text }}
        </p>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-between conf">
        <v-btn @click="dismiss(true)" large :color="confirmationButtonColour">{{
          confirmationButtonText
        }}</v-btn>
        <v-btn @click="dismiss(false)" large :color="rejectButtonColour">{{
          rejectButtonText
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const ERROR = "error",
  INFORMATION = "information",
  SUCCESS = "success",
  WARNING = "waring";

const alertTypes = {
  [WARNING]: {
    icon: "fa-exclamation-triangle text-danger",
    colour: "",
    title: "Warning",
    confirmBtnColour: "warning",
    rejectBtnColour: "primary"
  },
  [INFORMATION]: {
    icon: "fa-info-circle text-secondary",
    colour: "",
    title: "Be Advised",
    confirmBtnColour: "success",
    rejectBtnColour: "error"
  },
  [SUCCESS]: {
    icon: "fa-check-circle text-success",
    colour: "",
    title: "Success"
  },
  [ERROR]: {
    icon: "fa-exclamation-triangle text-danger",
    colour: "",
    title: "Error"
  }
};

export default {
  ERROR,
  INFORMATION,
  SUCCESS,
  WARNING,
  props: {
    iconSize: {
      type: Number,
      required: false,
      default: 8
    },
    dialogWidth: {
      type: Number,
      required: false,
      default: 400
    },
    type: {
      String,
      required: false,
      default: INFORMATION
    },
    iconColour: {
      type: String,
      required: false,
      default: ""
    },
    title: {
      type: String,
      required: true,
      default: ""
    },
    text: {
      type: String,
      required: false,
      default: ""
    },
    confirmBtnText: {
      type: String,
      required: false,
      default: "Yes"
    },
    rejectBtnText: {
      type: String,
      required: false,
      default: "No"
    },
    confirmBtnColour: {
      type: String,
      required: false,
      default: ""
    },
    rejectBtnColour: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    selectedIcon() {
      return !!alertTypes[this.type]
        ? alertTypes[this.type]
        : alertTypes.warning;
    },
    iconStyle() {
      const color = !!this.iconColour
        ? this.iconColour
        : this.selectedIcon.colour;
      return {
        color
      };
    },
    iconClass() {
      return ["fas", this.selectedIcon.icon, `fa-${this.iconSize}x`, "fa-fw"];
    },
    alertTitle() {
      return !!this.title ? this.title : this.selectedIcon.title;
    },
    confirmationButtonText() {
      return !!this.confirmBtnText ? this.confirmBtnText : "Yes";
    },
    rejectButtonText() {
      return !!this.rejectBtnText ? this.rejectBtnText : "No";
    },
    confirmationButtonColour() {
      if (this.confirmBtnColour) return this.confirmBtnColour;
      const colour = !!this.selectedIcon.confirmBtnColour
        ? this.selectedIcon.confirmBtnColour
        : "primary";
      return colour;
    },
    rejectButtonColour() {
      if (this.rejectBtnColour) return this.rejectBtnColour;
      const colour = !!this.selectedIcon.rejectBtnColour
        ? this.selectedIcon.rejectBtnColour
        : "primary";
      return colour;
    }
  },
  methods: {
    dismiss(response) {
      this.$emit("input", false);
      this.$emit("dismiss", response);
    }
  }
};
</script>
